<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">车辆维修审批</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">

          <el-form-item label="审批类型">
            <el-radio-group size="small" v-model="useApplyType" class="type-radio-type">
              <el-radio-button label="jt">集团</el-radio-button>
              <el-radio-button label="zgs">子公司</el-radio-button>
              <el-radio-button label="ys">原水</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <repair-use ref="create" :useApplyType="useApplyType" :userData="userData" :formByFather="form"></repair-use>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
              <div class="tip">
                <p v-if="useApplyType=='zgs'">* 修车费用金额较大需报集团分管副总同意</p>
                <p v-if="useApplyType=='jt'">* 重要保养和维修项目，需经分管副总审批</p>
                <p v-if="useApplyType=='ys'">* 重要保养和维修项目，需经分管副总、总经理审批</p>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <!-- <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom> -->

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitCar()" class="form-btn" type="success">确认提交车辆维修申请
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import RepairUse from '@/page/form/car/repair'
  export default {
    components: {
      ApprovalItem,
      RepairUse,
      ApprovalItem,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          depId: "",

          wxdw: "",
          carId: "",
          startTime: "",
          endTime: "",
          jbrId: "",
          reason: "",
          price: "",

          applyType: "",
          json: true,
        },
        useApplyType: "",
        // carType: "",
        approvalUsersData: '',
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      this.useApplyType = "jt"
      // this.carType = "1"
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      }
    },
    methods: {
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/car/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo

          this.form = this.applyInfo
          this.form.carId = this.form.car ? this.form.car.id : ''
          this.form.depId = this.form.department.id
          this.form.time = [this.form.startTime, this.form.endTime]
          this.form.applyId = this.form.flow.applyId
          this.form.json = true

          console.log(this.form.type)
          switch (this.form.type) {
            case 83:
              this.useApplyType = 'zgs'
              break;
            case 87:
              this.useApplyType = 'jt'
              break;
            case 91:
              this.useApplyType = 'ys'
              break;
          }
          this.form.applyType = this.form.type

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, this.applyInfo.type)
          this.formLoading = false
        })
      },
      // 提交维修车辆申请单
      SubmitCar() {
        this.form = this.$refs.create.getFromData()

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        if (!this.form.carId) {
          this.$message.error('请选择车辆，如无对应车辆信息，请联系相关同事添加')
          return
        }

        this.formLoading = true
        let _url = !this.form.applyId ? '/car/apply' : '/car/apply/edit?applyId=' + this.form.applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交车辆维修申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改车辆维修申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Car/RepairList/')
        }, (res) => {
          this.formLoading = false
        })
      },
      // 识别审批type
      calcApplyType() {
        switch (this.useApplyType) {
          case 'jt':
            this.form.applyType = '87'
            break;
          case 'zgs':
            this.form.applyType = '83'
            break;
          case 'ys':
            this.form.applyType = '91'
            break;
        }
        this.approvalUsersData = this.approvalUsers['c' + this.form.applyType]
        this.setSelectArr(this.applyInfo, this.form.applyType)
      },
    },
    watch: {
      'useApplyType'() {
        this.calcApplyType()
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/car/repairApply.vue